export default "__VITE_ASSET__DB9u_3UP__"